import {formatPublishDate, type NewsCardView} from '../../model';
import {newsHref} from '../../routing';
import type {CardListingItem} from '../grid-card-listing/listing-card-item';
import {CALENDAR_ICON} from './meta-icons';

export function newsCardProps(view: NewsCardView, locale: string): CardListingItem {
  const publishDate = formatPublishDate(view.publishedAt, locale);
  return {
    id: view.uuid,
    title: view.title,
    image: view.image.src,
    href: newsHref(locale, view.uuid),
    badges: view.categories.map(category => ({label: category.name})),
    // No date ⇒ no meta row — never a dangling calendar icon beside an empty label.
    primaryMeta: publishDate ? {label: publishDate, icon: CALENDAR_ICON} : undefined,
  };
}
